import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

export const fetchAnnouncements = async () => {
  try {
    const response = await axiosInstance.get(API.announcement.getAll);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const addAnnouncement = async (values) => {
  try {
    // Change values.announcementMessage to values.message
    await axiosInstance.post(API.announcement.add, {
      title: values.title,
      message: values.message, 
    });
  } catch (error) {
    console.error("Error", error);
    // Standardizing error handling for your professional UI
    throw new Error(error.response?.data?.message || "Failed to create announcement");
  }
};

export const editAnnouncement = async (payload) => {
  try {
    await axiosInstance.put(API.announcement.edit, payload
    );
  } catch (error) {
    console.error(error)
    throw error;
  }
};

export const deleteAnnouncement = async (id) => {
  try {
    await axiosInstance.delete(API.announcement.delete(id));
  } catch (error) {
    throw new Error("Failed to delete announcement: " + error.message);
  }
};
